const U = (id) => `https://images.unsplash.com/${id}?q=80&w=1600&auto=format&fit=crop`;
const M = (id) => `/media/${id}.jpeg`;

export const PACKAGES = [
  {
    slug: 'sao-tome-discovery',
    name: 'São Tomé Discovery',
    destination: 'São Tomé',
    islands: ['São Tomé'],
    duration: '3 dias',
    style: 'Estadia Curta',
    idealFor: 'Primeira visita a São Tomé',
    overview: 'Uma introdução perfeita à ilha: chegada com transfer, a icónica Rota do Cacau e tempo livre antes da partida.',
    highlights: ['North Tour & Cocoa Route', 'Transfer de aeroporto incluído', 'Apoio local Eco Collection'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada a São Tomé + transfer do aeroporto + check-in' },
      { day: 'Day 2', text: 'North Tour & Cocoa Route' },
      { day: 'Day 3', text: 'Manhã livre + transfer de partida' },
    ],
    accommodationNote: 'Alojamento local selecionado, conforme preferência',
    experiencesIncluded: ['North Tour & Cocoa Route'],
    transfersNote: 'Transfers de aeroporto incluídos',
    meals: 'Conforme alojamento escolhido',
    included: ['Alojamento', 'Transfer de aeroporto', 'Experiência North Tour & Cocoa Route', 'Apoio local'],
    notIncluded: ['Voos', 'Refeições não mencionadas', 'Despesas pessoais'],
    optional: ['Ilhéu Santana by Boat', 'Wild South & Pico Cão Grande'],
    important: ['Preço final sob consulta, conforme época e preferências'],
    partner: 'Navetur Equatur',
    img: M('fccf01a5-f373-4ff8-8fca-859836b4b58c'),
  },
  {
    slug: 'sao-tome-explorer',
    name: 'São Tomé Explorer',
    destination: 'São Tomé',
    islands: ['São Tomé'],
    duration: '5 dias',
    style: 'Explorador da Ilha',
    idealFor: 'Quem quer ver o essencial da ilha',
    overview: 'Cinco dias para explorar São Tomé de norte a sul, com mar, cacau e o selvagem Pico Cão Grande.',
    highlights: ['Norte e sul da ilha', 'Ilhéu Santana', 'Pico Cão Grande'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada & boas-vindas' },
      { day: 'Day 2', text: 'North Tour & Cocoa Route' },
      { day: 'Day 3', text: 'Wild South & Pico Cão Grande' },
      { day: 'Day 4', text: 'Ilhéu Santana / experiência selecionada' },
      { day: 'Day 5', text: 'Partida' },
    ],
    accommodationNote: 'Alojamento local selecionado',
    experiencesIncluded: ['North Tour & Cocoa Route', 'Wild South & Pico Cão Grande', 'Ilhéu Santana by Boat'],
    transfersNote: 'Transfers de aeroporto incluídos',
    meals: 'Conforme alojamento escolhido',
    included: ['Alojamento', 'Transfers', 'Experiências mencionadas', 'Apoio local'],
    notIncluded: ['Voos', 'Refeições não mencionadas'],
    optional: ['Experiência de gastronomia local'],
    important: ['Preço final sob consulta'],
    partner: 'Navetur Equatur',
    img: M('4923818b-7917-45ff-9853-4bb847436818'),
  },
  {
    slug: 'sao-tome-complete',
    name: 'São Tomé Complete',
    destination: 'São Tomé',
    islands: ['São Tomé'],
    duration: '8 dias',
    style: 'Ilha Completa',
    idealFor: 'A experiência mais completa de São Tomé',
    overview: 'A experiência mais completa da ilha, combinando norte, sul, mar, cultura, natureza e tempo livre.',
    highlights: ['Norte, sul e mar', 'Cultura e gastronomia', 'Tempo livre para praias'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada e ambientação' },
      { day: 'Day 2', text: 'North Tour & Cocoa Route' },
      { day: 'Day 3', text: 'Wild South & Pico Cão Grande' },
      { day: 'Day 4', text: 'Ilhéu Santana by Boat' },
      { day: 'Day 5', text: 'Natureza / cascata' },
      { day: 'Day 6', text: 'Cultura local & gastronomia' },
      { day: 'Day 7', text: 'Dia livre' },
      { day: 'Day 8', text: 'Partida' },
    ],
    accommodationNote: 'Alojamento local selecionado',
    experiencesIncluded: ['North Tour & Cocoa Route', 'Wild South & Pico Cão Grande', 'Ilhéu Santana by Boat', 'Experiência de natureza/cascata', 'Cultura local & gastronomia'],
    transfersNote: 'Transfers incluídos',
    meals: 'Conforme alojamento escolhido',
    included: ['Alojamento', 'Transfers', 'Experiências mencionadas', 'Apoio local'],
    notIncluded: ['Voos', 'Refeições não mencionadas'],
    optional: ['Upgrades de alojamento'],
    important: ['Preço final sob consulta'],
    partner: 'Navetur Equatur',
    img: M('e5e86e7f-1b6e-45a3-8aa3-0b6aa056a12a'),
  },
  {
    slug: 'principe-essential',
    name: 'Príncipe Essential',
    destination: 'Príncipe',
    islands: ['Príncipe'],
    duration: '3 dias',
    style: 'Estadia Curta',
    idealFor: 'Uma amostra do Príncipe',
    overview: 'O essencial da ilha do Príncipe em três dias: Santo António e o tour icónico das roças até à Praia Banana.',
    highlights: ['Discover Príncipe tour', 'Praia Banana', 'Santo António'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada + Santo António' },
      { day: 'Day 2', text: 'Discover Príncipe: Roças, História & Praia Banana' },
      { day: 'Day 3', text: 'Partida' },
    ],
    accommodationNote: 'Alojamento local selecionado',
    experiencesIncluded: ['Discover Príncipe: Roças, História & Praia Banana'],
    transfersNote: 'Transfers locais incluídos',
    meals: 'Almoço incluído no tour',
    included: ['Alojamento', 'Transfers locais', 'Discover Príncipe', 'Apoio local'],
    notIncluded: ['Voos / ligação São Tomé ↔ Príncipe', 'Refeições não mencionadas'],
    optional: ['Príncipe by Sea'],
    important: ['Preço final sob consulta'],
    partner: '',
    img: U('photo-1590523741831-ab7e8b8f9c7f'),
  },
  {
    slug: 'discover-principe-package',
    name: 'Discover Príncipe',
    destination: 'Príncipe',
    islands: ['Príncipe'],
    duration: '5 dias',
    style: 'Ilha Signature',
    idealFor: 'Three signature experiences. One island journey.',
    overview: 'Três experiências de assinatura. Uma viagem pela ilha: roças e história, biosfera e trilhos, e o Príncipe visto do mar.',
    highlights: ['Roças & Praia Banana', 'Biosphere & Trails', 'Príncipe by Sea'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada + alojamento' },
      { day: 'Day 2', text: 'Roças, História & Praia Banana' },
      { day: 'Day 3', text: 'Biosphere, Trails, Waterfalls & Communities' },
      { day: 'Day 4', text: 'Príncipe by Sea' },
      { day: 'Day 5', text: 'Manhã livre + partida' },
    ],
    accommodationNote: 'Alojamento local selecionado',
    experiencesIncluded: ['Discover Príncipe', 'Príncipe Biosphere', 'Príncipe by Sea'],
    transfersNote: 'Transfers locais incluídos',
    meals: 'Almoços incluídos nas experiências',
    included: ['Alojamento', 'Transfers locais', 'Três experiências de assinatura', 'Apoio local'],
    notIncluded: ['Voos / ligação São Tomé ↔ Príncipe'],
    optional: ['Dia extra de praia'],
    important: ['Preço final sob consulta'],
    partner: '',
    img: U('photo-1533760881669-80db4d7b4c15'),
  },
  {
    slug: 'stp-signature',
    name: 'São Tomé & Príncipe Signature',
    destination: 'São Tomé + Príncipe',
    islands: ['São Tomé', 'Príncipe'],
    duration: '8 dias',
    style: 'Duas Ilhas',
    idealFor: 'As duas ilhas numa só viagem',
    overview: 'O melhor das duas ilhas: cacau e sul selvagem em São Tomé, e o trio de assinatura do Príncipe.',
    highlights: ['Duas ilhas', 'Cacau + Biosfera + Mar', 'Apoio local contínuo'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada a São Tomé' },
      { day: 'Day 2', text: 'Norte & Cacau' },
      { day: 'Day 3', text: 'Wild South' },
      { day: 'Day 4', text: 'Transfer / voo para o Príncipe' },
      { day: 'Day 5', text: 'Roças & Praia Banana' },
      { day: 'Day 6', text: 'Biosphere & Trails' },
      { day: 'Day 7', text: 'Príncipe by Sea / tempo livre' },
      { day: 'Day 8', text: 'Partida' },
    ],
    accommodationNote: 'Alojamentos locais nas duas ilhas',
    experiencesIncluded: ['North Tour & Cocoa Route', 'Wild South & Pico Cão Grande', 'Discover Príncipe', 'Príncipe Biosphere', 'Príncipe by Sea'],
    transfersNote: 'Transfers e ligação entre ilhas coordenados pela Eco Collection',
    meals: 'Conforme programa',
    included: ['Alojamentos', 'Transfers', 'Experiências mencionadas', 'Apoio local'],
    notIncluded: ['Voos internacionais'],
    optional: ['Upgrades de alojamento'],
    important: ['Preço final sob consulta'],
    partner: 'Navetur Equatur',
    img: U('photo-1544551763-46a013bb70d5'),
  },
  {
    slug: 'stp-grand-journey',
    name: 'STP Grand Journey',
    destination: 'São Tomé + Príncipe',
    islands: ['São Tomé', 'Príncipe'],
    duration: '10 dias',
    style: 'Premium & Personalizável',
    idealFor: 'Viagem premium desenhada à medida',
    overview: 'O produto premium da Eco Collection: alojamento, transfers, múltiplas experiências, tempo livre, apoio local e upgrades opcionais — totalmente personalizável.',
    highlights: ['Totalmente personalizável', 'Premium', 'Upgrades opcionais'],
    itinerary: [
      { day: 'Day 1–4', text: 'São Tomé: norte, sul, mar e cultura' },
      { day: 'Day 5', text: 'Ligação ao Príncipe' },
      { day: 'Day 6–9', text: 'Príncipe: roças, biosfera, mar e tempo livre' },
      { day: 'Day 10', text: 'Partida' },
    ],
    accommodationNote: 'Alojamentos selecionados consigo',
    experiencesIncluded: ['Programa à medida'],
    transfersNote: 'Todos os transfers coordenados',
    meals: 'Conforme programa',
    included: ['Alojamentos', 'Transfers', 'Experiências combinadas', 'Apoio local dedicado'],
    notIncluded: ['Voos internacionais'],
    optional: ['Upgrades', 'Experiências extra', 'Noites adicionais'],
    important: ['Proposta personalizada sob consulta'],
    partner: '',
    img: U('photo-1662534068962-6b3fa9aed99d'),
    ctaProposal: true,
  },
  {
    slug: 'santiago-essential',
    name: 'Santiago Essential',
    destination: 'Santiago, Cabo Verde',
    islands: ['Santiago'],
    duration: '3 dias',
    style: 'Estadia Curta',
    idealFor: 'Praia + cultura + introdução à ilha',
    overview: 'Praia, cultura e uma introdução à ilha de Santiago em três dias.',
    highlights: ['Cidade Velha', 'Praia', 'Cultura crioula'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada / transfer' },
      { day: 'Day 2', text: 'Cidade Velha / região Sul + experiência local' },
      { day: 'Day 3', text: 'Partida' },
    ],
    accommodationNote: 'Alojamento local selecionado',
    experiencesIncluded: ['Experiência local à escolha'],
    transfersNote: 'Transfer de chegada incluído',
    meals: 'Conforme alojamento',
    included: ['Alojamento', 'Transfer de chegada', 'Experiência local', 'Apoio local'],
    notIncluded: ['Voos'],
    optional: ['Cachupa Cooking Experience'],
    important: ['Preço final sob consulta'],
    partner: 'Santiago Adventures',
    img: M('56467cf4-1c33-4530-bae3-1167dc9c64fa'),
  },
  {
    slug: 'santiago-explorer',
    name: 'Santiago Explorer',
    destination: 'Santiago, Cabo Verde',
    islands: ['Santiago'],
    duration: '5 dias',
    style: 'Explorador da Ilha',
    idealFor: 'Santiago completo: praia, interior e norte',
    overview: 'Praia, Cidade Velha, interior da ilha, norte de Santiago, Serra Malagueta / Tarrafal e cultura local em cinco dias.',
    highlights: ['Cidade Velha', 'Interior + Norte', 'Serra Malagueta / Tarrafal'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada' },
      { day: 'Day 2', text: 'Cidade Velha & região Sul' },
      { day: 'Day 3', text: 'Interior da ilha' },
      { day: 'Day 4', text: 'Norte de Santiago / Serra Malagueta / Tarrafal' },
      { day: 'Day 5', text: 'Cultura local + partida' },
    ],
    accommodationNote: 'Alojamento local selecionado',
    experiencesIncluded: ['Santiago Grand Island Tour', 'Authentic Northern Santiago'],
    transfersNote: 'Transfers incluídos',
    meals: 'Conforme programa',
    included: ['Alojamento', 'Transfers', 'Experiências mencionadas', 'Apoio local'],
    notIncluded: ['Voos'],
    optional: ['Traditional Fishing & Beach BBQ'],
    important: ['Preço final sob consulta'],
    partner: 'Santiago Adventures',
    img: U('photo-1770018894880-e71c4ba95bd2'),
  },
  {
    slug: 'santiago-active-local',
    name: 'Santiago Active & Local',
    destination: 'Santiago, Cabo Verde',
    islands: ['Santiago'],
    duration: '7 dias',
    style: 'Ativo & Local',
    idealFor: 'Viajantes ativos que querem viver a ilha',
    overview: 'Uma semana ativa e local em Santiago: ilha completa, trekking, mar, pesca tradicional e gastronomia.',
    highlights: ['Grand Island Tour', 'Trek Serra Malagueta', 'Pesca & BBQ + Cachupa'],
    itinerary: [
      { day: 'Day 1', text: 'Chegada' },
      { day: 'Day 2', text: 'Santiago Grand Island Tour' },
      { day: 'Day 3', text: 'Serra Malagueta → Vale Principal Trek' },
      { day: 'Day 4', text: 'Livre / Praia' },
      { day: 'Day 5', text: 'Traditional Fishing & Beach BBQ' },
      { day: 'Day 6', text: 'Cachupa Cooking & Cultura Local' },
      { day: 'Day 7', text: 'Partida' },
    ],
    accommodationNote: 'Alojamento local selecionado',
    experiencesIncluded: ['Santiago Grand Island Tour', 'Serra Malagueta → Vale de Principal Trek', 'Traditional Fishing & Private Beach BBQ', 'Cachupa Cooking Experience'],
    transfersNote: 'Transfers incluídos',
    meals: 'Conforme programa (almoços nas experiências)',
    included: ['Alojamento', 'Transfers', 'Experiências mencionadas', 'Apoio local'],
    notIncluded: ['Voos'],
    optional: ['Pico de Antónia Challenge'],
    important: ['Preço final sob consulta'],
    partner: 'Santiago Adventures',
    img: U('photo-1757788174731-bfc960b40756'),
  },
];

export const FEATURED_PACKAGES = ['sao-tome-explorer', 'discover-principe-package', 'stp-signature', 'santiago-active-local'];

export const packageBySlug = (slug) => PACKAGES.find((p) => p.slug === slug);

export const PACKAGE_INTERESTS = {
  'sao-tome-discovery': ['Cultura', 'Natureza'],
  'sao-tome-explorer': ['Natureza', 'Mar', 'Cultura'],
  'sao-tome-complete': ['Natureza', 'Mar', 'Cultura', 'Gastronomia'],
  'principe-essential': ['Praia', 'Cultura'],
  'discover-principe-package': ['Praia', 'Natureza', 'Mar'],
  'stp-signature': ['Natureza', 'Mar', 'Cultura', 'Praia'],
  'stp-grand-journey': ['Natureza', 'Mar', 'Cultura', 'Relaxamento'],
  'santiago-essential': ['Praia', 'Cultura'],
  'santiago-explorer': ['Cultura', 'Natureza', 'Praia'],
  'santiago-active-local': ['Caminhada', 'Mar', 'Gastronomia', 'Aventura'],
};
